import { memo } from 'react';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import { useStyles } from './ErrorMessage.styles';
import { ErrorMessageProps } from './ErrorMessage.types';

export const ErrorMessage = memo(({ errorTitle, errorMessage }: ErrorMessageProps) => {
  const styles = useStyles();

  return (
    <Grid
      data-testid="error-message"
      className={styles.container}
      spacing={3}
      container
      alignItems="center"
      justifyContent="center"
      direction="column"
    >
      <Grid item>
        <Typography variant="h1" color="secondary">
          Error
        </Typography>
      </Grid>

      <Grid item>
        <Typography variant="body1">
          <strong>{errorTitle}</strong>
        </Typography>

        <Typography variant="body1">{errorMessage}</Typography>
      </Grid>
    </Grid>
  );
});
